import AddDataPage from './components/addDataPage'

export default function AddData() {
  return <AddDataPage />
}
